import { render, staticRenderFns } from "./BookingLegend.vue?vue&type=template&id=1a324844&scoped=true&"
import script from "./BookingLegend.vue?vue&type=script&lang=js&"
export * from "./BookingLegend.vue?vue&type=script&lang=js&"
import style0 from "./BookingLegend.vue?vue&type=style&index=0&id=1a324844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a324844",
  null
  
)

export default component.exports